export const ENTITY_TYPE_OPTIONS = [
  { value: "R", label: "RESTAURANT" },
  { value: "F", label: "FAST-FOOD" },
  { value: "S", label: "CAFÉ-SNACK" },
  { value: "P", label: "SALON DE THÉ-PÂTISSERIE-CRÊMERIE" },
  { value: "T", label: "SERVICE TRAITEUR -VENTES SUR COMMANDES" },
  { value: "Z", label: "TABLE D'HÔTES" },
  { value: "A", label: "AUTRES" },
] as const;

export type EntityType = (typeof ENTITY_TYPE_OPTIONS)[number]["value"];
export function getEntityTypeLabel(value: EntityType): string {
  return ENTITY_TYPE_OPTIONS.find((t) => t.value === value)?.label || value;
}
